import { IDashboardDictionary } from "~/lang/types/dashboard"

export const dashboardDictionary: IDashboardDictionary = {
  canceled: {
    title:
      "The cargo of Awang-Diyei company has been canceled by the admin (Sara Hosseini)!",
  },
  pending: {
    title: "Is the cargo of Awang-Meeteh company approved?",
    reject: "Reject cargo",
    confirm: "Confirm cargo",
  },
  billOfLading: {
    billOfLadingPrice: "bill of lading price",
  },
}
